module.exports = __webpack_public_path__ + "img/create-arrow.828f63f7.svg";